import { render, staticRenderFns } from "./MoveEditor.vue?vue&type=template&id=fdfdf3a8"
import script from "./MoveEditor.vue?vue&type=script&lang=js"
export * from "./MoveEditor.vue?vue&type=script&lang=js"
import style0 from "./MoveEditor.vue?vue&type=style&index=0&id=fdfdf3a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports